import _defineProperty from "@babel/runtime/helpers/defineProperty";
export const FETCH_ERROR_NAME = 'FetchError';
export class FetchError extends Error {
  constructor(message, status) {
    super(message);
    _defineProperty(this, "name", FETCH_ERROR_NAME);
    this.status = status;
  }
  static isFetchError(value) {
    if (process.env.NODE_ENV === 'testing') {
      // jest messes up globals badly, see https://github.com/facebook/jest/issues/2549
      // once that issue is fixed, the usages of this function can be inlined to `error instanceof BadStatusError`
      return (value === null || value === void 0 ? void 0 : value.name) === FETCH_ERROR_NAME;
    }
    return value instanceof FetchError;
  }
}